

import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { tsx } from "@arcgis/core/widgets/support/widget";

import FeatureLayer from '@arcgis/core/layers/FeatureLayer'
import Graphic from "@arcgis/core/Graphic"
import { Layer } from './layers'

const CSS = {
    base: "valueslider"
};

@subclass("esri.widgets.PresetPanel")
class ValueSlider extends Widget {

    @property()
    layer?: Layer

    @property()
    slideField: string[] = ['params', 'value']

    @property()
    callback: ((value: number) => void) | null = null

    @property()
    value: number = 0

    @property()
    min: number = 0

    @property()
    max: number = 0

    @property()
    step: number = 0

    @property()
    labels: string[] = []

    @property()
    pretext: string = ''

    @property()
    posttext: string = ''

    constructor(params: any) {
        super(params);
        this.update = this.update.bind(this)
        this.updateValue = this.updateValue.bind(this)
    }

    postInitialize() {
        this.updateValue()
    }

    updateValue() {
        if(!this.layer) return;

        if (this.slideField && this.slideField.length > 1) {
            let tmp = this.layer[this.slideField[0]]
            for (let i = 1; i < this.slideField.length - 1; i++) {
                tmp = tmp[this.slideField[i]]
            }
            tmp[this.slideField[this.slideField.length - 1]] = this.value

        } else if (this.slideField && this.slideField.length == 1){
            this.layer[this.slideField[0]] = this.value
        }
    }

    update(e: any) {
        this.value = parseFloat($(e.target).val() as string)
        this.updateValue()
        if (this.callback) {
            this.callback(this.value)
        }
        if (this.layer) {
            this.layer.onUpdate(e)
        }
    }

    render() {
        let labelObjects = []
        for (let label of this.labels) {
            labelObjects.push(<span>{label}</span>)
        }

        return (
            <div class={this.classes(CSS.base)}>
                <div class="row">
                    <div class="col-md-12">
                        {this.pretext}
                        <span style="display:inline-block">
                            <input id="directinput" type="number"
                                    min={this.min} max={this.max} value={this.value} oninput={this.update} />
                        </span>
                        {this.posttext}
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-md-12">
                        <div id="sliderLabels" class="slider-labels">
                            {labelObjects}
                        </div>
                        <div id="rangeWrapper">
                            <input id="slider" class="calcite-slider" type="range" min={this.min} max={this.max}
                                step={this.step} value={this.value} style="width: 100%;" oninput={this.update} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ValueSlider